import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-384ecced"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lti-wrapper" }
const _hoisted_2 = ["aria-label", "disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "lti-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.09 8.99999C9.32504 8.3324 9.78924 7.76915 10.4 7.40971C11.0107 7.05027 11.7265 6.91778 12.4218 7.03387C13.1171 7.14995 13.7498 7.50661 14.2071 8.04312C14.6644 8.57964 14.9177 9.26115 14.92 9.96999C14.92 12 12.42 12.95 12.42 12.95V14",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "17",
    r: "1"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "lti-modal-content" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

import { ref, computed } from "vue";
import LingoTooltip from "./LingoTooltipComponent.vue";
import LingoModal from "./LingoModalComponent.vue";

type Props = {
  text?: string;
  supporting?: string;
  placement?: "top" | "bottom" | "left" | "right";
  align?: "start" | "center" | "end";
  size?: "sm" | "md" | "lg";
  ariaLabel?: string;
  disabled?: boolean;
  openOnClick?: boolean;
  showArrow?: boolean;
  openModalOnClick?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'LingoTooltipIconComponent',
  props: {
    text: { default: "This is a tooltip" },
    supporting: { default: "" },
    placement: { default: "top" },
    align: { default: "center" },
    size: { default: "md" },
    ariaLabel: { default: "Help" },
    disabled: { type: Boolean, default: false },
    openOnClick: { type: Boolean, default: true },
    showArrow: { type: Boolean, default: true },
    openModalOnClick: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;



const {
  text,
  supporting,
  placement,
  align,
  size,
  ariaLabel,
  disabled,
  openOnClick,
  showArrow,
  openModalOnClick,
} = props as Required<Props>;

const showModal = ref(false);

const modalTitle = computed(() => ariaLabel || "Info");

function onTriggerClick(event?: MouseEvent) {
  if (disabled) return;

  if (openModalOnClick) {
    if (event?.stopPropagation) event.stopPropagation();
    if (event?.preventDefault) event.preventDefault();
    showModal.value = true;
    return;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(LingoTooltip, {
      text: _unref(text),
      supporting: _unref(supporting),
      placement: _unref(placement),
      align: _unref(align),
      "open-on-click": _unref(openOnClick),
      disabled: _unref(disabled),
      "show-arrow": _unref(showArrow)
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["lti-btn", [`lti--${_unref(size)}`, _unref(disabled) ? 'is-disabled' : '']]),
          "aria-label": _unref(ariaLabel) || 'Help',
          disabled: _unref(disabled),
          onClick: onTriggerClick
        }, _hoisted_4, 10, _hoisted_2)
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["text", "supporting", "placement", "align", "open-on-click", "disabled", "show-arrow"]),
    (_unref(openModalOnClick))
      ? (_openBlock(), _createBlock(LingoModal, {
          key: 0,
          modelValue: showModal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
          title: modalTitle.value,
          centered: "",
          "show-close-button": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_unref(text))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "lti-modal-text",
                    innerHTML: _unref(text)
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_unref(supporting))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "lti-modal-supporting",
                    innerHTML: _unref(supporting)
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "lti-modal-close-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false))
            }, "Got it")
          ]),
          _: 1
        }, 8, ["modelValue", "title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})